import type { AppMode } from '@common/types/config/AppMode'
import type {
	Module,
	ModuleConfig,
	ModuleOptions,
} from '@common/types/config/Modules'

export function computePathForModule(
	moduleConfig: ModuleConfig,
	mode: AppMode,
	module: Module,
): string {
	const forMode =
		moduleConfig.length === 1
			? moduleConfig[0]
			: moduleConfig.find(m => m.mode === mode)
	if (!forMode) return '/'
	const forModule = forMode.modules.find(m => m.module === module)
	if (!forModule) return '/'

	if (moduleConfig.length === 1) return forModule.path
	else return forMode.base + forModule.path
}

export type ModuleObject = {
	path: string
	mode: AppMode
	module: Module
	options?: ModuleOptions[keyof ModuleOptions]
}

export function computeModules(moduleConfig: ModuleConfig): ModuleObject[] {
	return moduleConfig.flatMap(({ mode, base, modules }) =>
		modules.map(({ module, path, options }) => {
			if (moduleConfig.length === 1)
				return { mode, module, path, options }
			else
				return {
					mode,
					module,
					path: base + path,
					options,
				}
		}),
	)
}

export function formatMode(mode: string) {
	return (
		String(mode).charAt(0).toUpperCase() +
		String(mode)
			.slice(1)
			.replaceAll(/-(.)/g, (_, l) => l.toUpperCase())
	)
}
